import React from 'react';
import './SixthSection.css';
import sixthSection from '../assets/images/sixthSection.png';
import sixthSection1 from '../assets/images/sixthSection1.png';
import sixthSection2 from '../assets/images/sixthSection2.png';
import useScrollAnimation from '../hooks/useScrollAnimation';

const SixthSection = () => {
  const craftImages = [
    { src: sixthSection, alt: 'Woodworking Process 1' },
    { src: sixthSection1, alt: 'Woodworking Process 2' },
    { src: sixthSection2, alt: 'Woodworking Process 3' },
  ];
  
  // Scroll animations
  const [sectionRef, isSectionVisible] = useScrollAnimation(0.6);
  const [titleRef, isTitleVisible] = useScrollAnimation(0.7);
  const [textRef, isTextVisible] = useScrollAnimation(0.8);
  const [imagesRef, isImagesVisible] = useScrollAnimation(0.9);

  return (
    <section ref={sectionRef} className="sixth-section">
      <div className="sixth-container">
        <div className="sixth-content">
          {/* Title and Description Row */}
          <div className="sixth-text-row">
            <div ref={titleRef} className={`sixth-title-container ${isTitleVisible ? 'visible' : ''}`}>
              <h2 className={`sixth-title text-reveal ${isTitleVisible ? 'visible' : ''}`}>HOW WE CRAFT</h2>
            </div>
            <div ref={textRef} className={`sixth-description ${isTextVisible ? 'visible' : ''}`}>
              <p className={`text-reveal stagger-1 ${isTextVisible ? 'visible' : ''}`}>
                All the wood is chemically treated against worms and kiln dried in seasoning kilns to a moisture content below 6-8% prior to using in furniture construction. International grade of glue is used along with tenon and mortoise joinery. Although imported plant and machinery are used for faster processing of raw material, yet to preserve handmade elegance most of the remaining task is accomplished using handmade techniques only. Therefore minor variation in sizes and surface indentations should be allowed for. This feature adds to the charm of this furniture and combined with cathedral like grain of sheesham gives Indian furniture it's one of a kind unique and distinctive character. we guarantee the seams in our furniture will not open beyond a slight movement that may be expected with this type of furniture in extreme climates.
              </p>
            </div>
          </div>
          
          {/* Images Row */}
          <div ref={imagesRef} className={`sixth-images-row ${isImagesVisible ? 'visible' : ''}`}>
            <div className="sixth-images-grid">
              {craftImages.map((image, index) => (
                <div key={index} className={`sixth-image-container fade-in ${isImagesVisible ? 'visible' : ''}`}>
                  <img 
                    src={image.src} 
                    alt={image.alt} 
                    className={`sixth-image image-reveal ${isImagesVisible ? 'visible' : ''}`}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SixthSection;
